<template>
  <div class="AuthBypassLogin">
    <div class="loader" style="height: 40vh; position: relative; top: 250px">
      <div v-loading="is_login_loading" style=""></div>
    </div>
  </div>
</template>
<script>
import { serverAddr } from "../networkConfig";
import { loginNetworkCallBack } from "../mixins/login.NetworkCallback";
import { DeviceInfoCallBack } from "../mixins/DeviceInfo";
import { HelperNetworkCallBack } from "../mixins/Helper";

export default {
  name: "AuthBypassLogin",

  components: {},

  mixins: [loginNetworkCallBack, DeviceInfoCallBack, HelperNetworkCallBack],

  data() {
    return {
      is_login_loading: false,
      deviceInfo: {},
    };
  },
  async created() {},

  beforeRouteEnter(to, from, next) {
    let websiteUserType = JSON.parse(localStorage.getItem("websiteUserType"));

    if (websiteUserType && websiteUserType.userType == "stockAnts") {
      return next({ name: "login" });
    }

    next();
  },

  async mounted() {
    try {
      this.deviceInfo = await this.getUniqueDeviceInfo();
      this.authBypassLogin();
    } catch (error) {
      console.error('Error fetching device info:', error);
    }
  },

  methods: {
    authBypassLogin() {
      this.is_login_loading = true; //enabled loader
      serverAddr
        .post(`auth/v1/valdate/domain`, {
          device_info: this.deviceInfo,
        })
        .then((response) => {
          if (response.data.start_onboarding) {
            // this.$router.push("/verify-user");

            this.$router.push({
              name: "verifyUser",
              params: { deviceData: this.deviceInfo },
            });
          } else {
            console.log(response.data.start_onboarding);
            this.loginUserNetworkCallBack(response);
            this.is_login_loading = false; //disabled loader
          }
        })
        .catch((error) => {
          console.log(error);
          this.is_login_loading = false; //disabled loader
        });
    },
  },
};
</script>
